import { Create } from "@components/modules/invoices/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { RequestForInvoicingNavigation } from "@src/components/widgets/AppSubNav/navigation-invoices/requests-for-invoicing";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    title={t`Create proforma invoice`}
    navigation={<RequestForInvoicingNavigation />}
  >
    <Create.Proforma />
  </MainLayout>
);

export const Route = createFileRoute("/invoices/for-invoicing/create-proforma")(
  {
    component: Page,
  },
);
